<template>
	<div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 800px">
		<div>
			<!-- <loading /> -->
			<p style="font-weight: bold; text-align: center;">The page you are looking for is not found.<br>Redirecting to home ...</p>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		},
		created() {

			setTimeout(() => {
				this.$router.push("/my_profile");
			}, 2000)

			
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue